import LayoutAuth from "../../layout/LayoutAuth";
import LoginForm from '../../forms/auth/LoginForm';

export default function Login(){
    return(
        <LayoutAuth>
            <LoginForm/>
        </LayoutAuth>
    );
}